/**
 * Handles s buffer type.
 */
export enum HsBufferType {
  arrayBuffer = 'ARRAY_BUFFER',
  elementBuffer = 'ELEMENT_ARRAY_BUFFER',
}
